import { render, staticRenderFns } from "./loginTenant.vue?vue&type=template&id=71413cfc&"
import script from "./loginTenant.vue?vue&type=script&lang=ts&"
export * from "./loginTenant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports